module.exports = __webpack_public_path__ + "img/piston-schematic-light.dcc9b4f5.png";